import styled from "styled-components";

export const PasswordResetAreaWrapper = styled("div")(() => {
  return {
    overflow: "hidden",
    backgroundColor: "var(--color-background)",
    padding: "var(--cardPadding)",
    borderRadius: "0.85rem",
    display: "grid",
    gap: "1.5rem",
    "@media screen and (max-width: 425px)": {
      padding: "var(--cardPadding) 0",
    },
    "& h2": {
      margin: 0,
    },
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "var(--color-primary)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      display: "inline-block",
    },
    "& select, & input": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) / 2)",
      borderRadius: "0.45rem",
      border: "1px solid var(--color-primary-hover)",
      fontWeight: "400",
      color: "var(--color-text)",
      backgroundColor: "var(--color-button-secondary)",
      "&:focus": {
        outline: "1px solid var(--color-primary)",
        border: "1px solid var(--color-primary-hover)",
      },
    },
    "& select option": {
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
    },
    "& form": {
      display: "grid",
      gap: "1.5rem",
    },
    "& fieldset": {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      border: "none",
      margin: 0,
      padding: 0,
      position: "relative",
    },
    "& button": {
      padding: "calc(var(--cardPadding) / 2) calc(var(--cardPadding) / 2)",
    },
  };
});
